module.exports = __webpack_public_path__ + "static/media/fleetvehiclesIcon.5713a80e.svg";